import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import DocumentMedia from "@/components/media/document.vue"
  import ImageMedia from "@/components/media/image.vue"
  import VideoMedia from "@/components/media/video.vue"
  import Enumeration from "@/components/selectors/enumeration.vue"
  import TextInput from "@/components/inputs/text.vue"
  import FileInput from "@/components/inputs/file.vue"
  import {PropType, useTemplateRef} from "vue"
  import {File} from "@/endpoints/rutsolve/gql/generated/graphql"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'file',
  props: /*@__PURE__*/_mergeModels({
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    }
  }, {
    "value": {
    default: null,
    required: true,
    type: Object as PropType<File>
  },
    "valueModifiers": {},
  }),
  emits: ["update:value"],
  setup(__props) {

  

  const value = _useModel(__props, "value")

  const fileInput = useTemplateRef("fileInput")

  function update() {
    value.value.data = fileInput.value.files[0].data
    value.value.extension = fileInput.value.files[0].extension
    value.value.name = fileInput.value.files[0].name
    value.value.url = null
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (value.value)
    ? (_openBlock(), _createBlock(_component_scoped, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(Enumeration, {
            selection: value.value.type,
            "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => ((value.value.type) = $event)),
            title: "Type",
            options: ['DOCUMENT', 'PICTURE', 'VIDEO'],
            readOnly: __props.readOnly
          }, null, 8, ["selection", "readOnly"]),
          (value.value.type == 'DOCUMENT')
            ? (_openBlock(), _createBlock(DocumentMedia, {
                key: 0,
                data: value.value.data,
                extension: value.value.extension,
                title: value.value.name,
                url: value.value.url
              }, null, 8, ["data", "extension", "title", "url"]))
            : _createCommentVNode("", true),
          (value.value.type == 'PICTURE')
            ? (_openBlock(), _createBlock(ImageMedia, {
                key: 1,
                data: value.value.data,
                extension: value.value.extension,
                title: value.value.name,
                url: value.value.url
              }, null, 8, ["data", "extension", "title", "url"]))
            : _createCommentVNode("", true),
          (value.value.type == 'VIDEO')
            ? (_openBlock(), _createBlock(VideoMedia, {
                key: 2,
                data: value.value.data,
                extension: value.value.extension,
                title: value.value.name,
                url: value.value.url
              }, null, 8, ["data", "extension", "title", "url"]))
            : _createCommentVNode("", true),
          _createVNode(TextInput, {
            value: value.value.name,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((value.value.name) = $event)),
            title: "Name",
            readOnly: __props.readOnly
          }, null, 8, ["value", "readOnly"]),
          _createVNode(TextInput, {
            value: value.value.extension,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((value.value.extension) = $event)),
            readOnly: "",
            title: "Extension"
          }, null, 8, ["value"]),
          _createVNode(TextInput, {
            value: value.value.description,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((value.value.description) = $event)),
            title: "Description",
            readOnly: __props.readOnly,
            multiline: ""
          }, null, 8, ["value", "readOnly"]),
          (!__props.readOnly)
            ? (_openBlock(), _createBlock(FileInput, {
                key: 3,
                ref_key: "fileInput",
                ref: fileInput,
                title: "Change File",
                onUpdate: _cache[4] || (_cache[4] = ($event: any) => (update()))
              }, null, 512))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})